import React from 'react'
import { replaceText } from '../../../utils/replaceText'
import { userContext } from './FormComponent';
import { useContext } from 'react';

export const Presentation = ({title, msj, msj2,footer}) => {
  const {
    parametrosURL,
  } = useContext(userContext);
  return (
    <div className="presentation">
      <h6  dangerouslySetInnerHTML={{__html:replaceText(title, parametrosURL)}}></h6>
      <p  dangerouslySetInnerHTML={{__html:replaceText(msj,parametrosURL)}}></p>
      <p  dangerouslySetInnerHTML={{__html:msj2}}></p>
      <small dangerouslySetInnerHTML={{__html:footer}}></small>
   </div>
  )
}
